export default [
  { value: 'prek', text: 'PreK' },
  { value: 'k-2', text: 'K-2' },
  { value: '3-5', text: '3-5' },
  { value: '6-8', text: '6-8' },
  { value: '9-12', text: '9-12' },
  { value: 'college', text: 'College' }
]
